import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { forwardRef } from "react";
export const Input = forwardRef(function Input({ className, ...rest }, ref) {
    return _jsx("input", { ref: ref, className: clsx("input", className), ...rest });
});
//# sourceMappingURL=Input.js.map